<template>
  <transition name="modal-fade">
    <div
      :style="
        $vuetify.theme.dark ? 'backgroud: var(--v-surface_secondary);'
                            : 'background: white;'
      " 
      class="modal-backdrop"
    >
      <div
        class="modal"
        :style="
          $vuetify.theme.dark ? 'background: white;'
                              : 'background: var(--v-surface_tertiary-base);'
        "
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div class="header">
          <button
            type="button"
            class="btn-close"
            @click="closeMidiaModal"
            aria-label="Close modal"
          >
            <CloseButton />
          </button>
        </div>

        <div class="body">
          <div class="interrogacaoWrapper">
            <Interrogacao class="interrogacao" />
          </div>

          <h2
            :style="$vuetify.theme.dark ? 'color: #171717;'
                                        : 'color: #1A1E20;'" 
          >
            Instruções
          </h2>

          <p>
            Para acessar o sistema, clique no botão e utilize seu email e senha
            corporativos. Caso precise de ajuda, entre em contato com o Help
            Desk.
          </p>

          <p>
            Ligue para <strong>3911</strong> se estiver na Globo. <br />Se
            estiver fora, ligue para <strong>0800 728 4855</strong>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CloseButton from "@/assets/close.svg";
import Interrogacao from "@/assets/interrogacao.svg";
export default {
  components: { CloseButton, Interrogacao },
  methods: {
    closeMidiaModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
// Bespoke modal: this component does NOT use v-dialog. It renders a custom
// fixed-position backdrop with a centered card and a top-right close button.
// The .header / .body here are NOT semantic equivalents of sc-modal__header
// / sc-modal__body (which are title+subtitle and flex-column body) — they
// are a close-button bar and a centered-text panel. Intentionally left
// scoped; do NOT migrate to sc-modal__* without restructuring the layout.
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.modal {
  overflow-x: visible;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  border-radius: 0.5rem;
  width: 31rem;
  height: 32.5rem;
}

div.header {
  align-self: flex-start;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: row;
  display: flex;
  // height: 2rem;
  button {
    padding: 1.5rem;
    scale: 1.2;
    // align-self: flex-end;
    background-color: transparent;
  }
}

div.body {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;

  .interrogacaoWrapper {
    // vertical-align: middle;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--v-primary-base);

    .interrogacao {
      width: 100%;
    }
  }

  h2 {
    margin-top: 2rem;
    margin-bottom: 3rem;
    font-weight: 700;
    font-size: 1.1rem;
  }

  p {
    width: 304px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 22.4px;
    color: #323232;
  }

  p + p {
    margin-top: 4rem;
  }

  strong {
    color: var(--v-primary-base);
  }
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
